import { HTMLAttributes } from "react";
import styled from "styled-components";
import { colors } from "../../styles/figmaColors";

export type sizeOptionsIconCircle = "S" | "M";

const sizeOptions: {
  [key in sizeOptionsIconCircle]: { diameter: number; iconSize: number };
} = {
  S: { diameter: 1.75, iconSize: 1 },
  M: { diameter: 2.75, iconSize: 1.5 },
};

export interface IconCircleProps extends HTMLAttributes<HTMLButtonElement> {
  iconColor?: keyof typeof iconColorsProps;
  icon: JSX.Element;
  backgroundColor?: keyof typeof iconColorsProps;
  size?: sizeOptionsIconCircle;
}

export const IconCircle = (props: IconCircleProps) => {
  const { iconColor, icon, backgroundColor, size } = props;
  const { diameter, iconSize } = sizeOptions[size ?? "M"];

  return (
    <StyledContainer $backgroundColor={backgroundColor} $diameter={diameter}>
      {icon && (
        <StyledIcon $iconColor={iconColor} $iconSize={iconSize}>
          {icon}
        </StyledIcon>
      )}
    </StyledContainer>
  );
};

interface StyledContainerArgs {
  $iconColor?: keyof typeof iconColorsProps;
  $backgroundColor?: keyof typeof iconColorsProps;
  $diameter?: number;
  $iconSize?: number;
}

const StyledIcon = styled.div<StyledContainerArgs>`
  display: flex;
  align-items: center;
  fill: ${({ $iconColor }) =>
    $iconColor ? iconColorsProps[$iconColor] : iconColorsProps["textBlack"]};
  & svg {
    width: ${({ $iconSize }) => $iconSize}rem;
    height: ${({ $iconSize }) => $iconSize}rem;
  }
`;

const StyledContainer = styled.div<StyledContainerArgs>`
  display: flex;
  justify-content: center;
  min-width: ${({ $diameter }) => $diameter}rem;
  width: ${({ $diameter }) => $diameter}rem;
  height: ${({ $diameter }) => $diameter}rem;
  border-radius: 6.2rem;
  background : ${({ $backgroundColor }) =>
    $backgroundColor
      ? iconColorsProps[$backgroundColor]
      : colors["colors/surfaces/background/background_level1"]}};
`;

const iconColorsProps = {
  errorNormal: colors["colors/system/error/error_normal"],
  textBlack: colors["colors/text/black"],
  accent500: colors["colors/accent/500"],
  textWhite: colors["colors/text/white"],
};
